import axios from 'axios';
const SERVER_URL = "https://comites.api.antp.org.mx";
//const SERVER_URL = "http://localhost:8000";

const fallo_token = {
    success: false,
    data:{
        status: 5
    }
}

const omitir_token = {
    success: true,
    data:{
        status: 10
    }
}

export let whoAmI = async (comite) => {

    const LOGIN_ADMIN = `${SERVER_URL}/api/whoami/${comite}`;

    let responseAdmin = await axios.get(LOGIN_ADMIN, { headers: {"Authorization" : `Bearer ${localStorage.token}`} });

           try{

            return responseAdmin.data;
           }catch(e){
            
            return fallo_token.data;
               
           }
}

export let isLoginAdmin = async () => {

    const LOGIN_ADMIN = `${SERVER_URL}/api/isadmin`;

    let responseAdmin = await axios.get(LOGIN_ADMIN, { headers: {"Authorization" : `Bearer ${localStorage.token}`} });

           try{
                
                return responseAdmin.data;
            
           }catch(e){
            
               return fallo_token.data;
           }
}

export const login = async (data) => {
    const LOGIN_ENDPOINT = `${SERVER_URL}/api/login`;
    

    try {

        let response = await axios.post(LOGIN_ENDPOINT, data);

        if(response.data.success){
            let jwt = response.data.token;

            localStorage.setItem("token", jwt);

            
            

        }

        return response.data;

    } catch(e){
        console.log(e);
        return fallo_token.data;
    }

    

}

export const register = async (data) => {
    const SIGNUP_ENDPOINT = `${SERVER_URL}/api/register`;
    try {
        let response = await axios({
            method: 'post',
            responseType: 'json',
            url: SIGNUP_ENDPOINT,
            data: data
          });

return response.data;

    } catch(e){
        console.log(e);
        return fallo_token;
    }
}

export const logout = () => {

        localStorage.removeItem("token");
    
}

export const comites = async() => {

    const LOGIN_ENDPOINT = `${SERVER_URL}/api/comites`;

    try {

        let response = await axios.get(LOGIN_ENDPOINT, { headers: {"Authorization" : `Bearer ${localStorage.token}`} });
        
        return response.data;

    } catch(e){
        console.log(e);
        return fallo_token;
    }

}

export const titular_comites = async () => {

    const LOGIN_ENDPOINT = `${SERVER_URL}/api/titular`;

    try {

        let response = await axios.get(LOGIN_ENDPOINT, { headers: {"Authorization" : `Bearer ${localStorage.token}`}});
        return response.data;

    } catch(e){
        console.log(e);
        return fallo_token.data;
    }

}


export const agregar_titular_comite = async (data) => {
    
    const LOGIN_ENDPOINT = `${SERVER_URL}/api/titular`;

    try {

        let response = await axios.post(LOGIN_ENDPOINT, data, { headers: {Authorization : `Bearer ${localStorage.token}`} });

        return response.data;

    } catch(e){
        console.log(e);
        return fallo_token.data;
    }

}

export const titular_comite_representantes = async (comite) => {

    const LOGIN_ENDPOINT = `${SERVER_URL}/api/${comite}/representantes`;

    try {

        let response = await axios.get(LOGIN_ENDPOINT,{ headers: {"Authorization" : `Bearer ${localStorage.token}`}});
        return response.data;

    } catch(e){
        console.log(e);
        return fallo_token.data;
    }

}

export const agregar_titular_comite_representante = async (comite,data) => {
    
    const LOGIN_ENDPOINT = `${SERVER_URL}/api/${comite}/representantes`;

    try {

        let response = await axios.post(LOGIN_ENDPOINT, data, { headers: {Authorization : `Bearer ${localStorage.token}`} });

        return response.data;

    } catch(e){
        console.log(e);
        return fallo_token.data;
    }

}

export const actualizarTitular = async (data) => {
    const LOGIN_ENDPOINT = `${SERVER_URL}/api/nuevo-titular`;

    try {

        let response = await axios.post(LOGIN_ENDPOINT, data, { headers: {Authorization : `Bearer ${localStorage.token}`} });

        return response.data;

    } catch(e){
        console.log(e);
        return fallo_token.data;
    }
}

export const eliminar_titular_comite_representante = async (comite, grupo_comite_representante) => {
    
    const LOGIN_ENDPOINT = `${SERVER_URL}/api/${comite}/representante/${grupo_comite_representante}`;

    try {

        let response = await axios.delete(LOGIN_ENDPOINT,{ headers: {Authorization : `Bearer ${localStorage.token}`} });

        return omitir_token;

    } catch(e){
        console.log(e);
        return fallo_token;
    }

}

export const titular_comite_representante = async (comite,representante) => {

    const LOGIN_ENDPOINT = `${SERVER_URL}/api/${comite}/representante/${representante}`;

    try {
        let response = await axios.get(LOGIN_ENDPOINT,{ headers: {"Authorization" : `Bearer ${localStorage.token}`}});
        return response.data;
    } catch(e){
        console.log(e);
        return fallo_token.data;
    }

}

export const agregar_comite_representante = async (comite,representante, data) => {
    
    const LOGIN_ENDPOINT = `${SERVER_URL}/api/${comite}/representante/${representante}`;

    try {

        let response = await axios.post(LOGIN_ENDPOINT,data, { headers: {Authorization : `Bearer ${localStorage.token}`} });

        return response.data;

    } catch(e){
        console.log(e);
        return fallo_token.data;
    }

}

export const actualizar_campos_representante = async (data) => {
    const LOGIN_ENDPOINT = `${SERVER_URL}/api/actualizar-representante`;

    try {

        let response = await axios.post(LOGIN_ENDPOINT,data, { headers: {Authorization : `Bearer ${localStorage.token}`} });

        return response.data;

    } catch(e){
        console.log(e);
        return fallo_token.data;
    }
}

export const eliminar_representante = async (comite,representante) => {

    const LOGIN_ENDPOINT = `${SERVER_URL}/api/${comite}/representantes/${representante}`;

    try {
        let response = await axios.delete(LOGIN_ENDPOINT,{ headers: {"Authorization" : `Bearer ${localStorage.token}`}});
        return omitir_token.data;
    } catch(e){
        console.log(e);
        return fallo_token.data;
    }

}

export const actualizar_representante = async(comite,representante_id, data) => {
    const LOGIN_ENDPOINT = `${SERVER_URL}/api/${comite}/representantes/${representante_id}`;

    try {
        let response = await axios.put(LOGIN_ENDPOINT,data, { headers: {"Authorization" : `Bearer ${localStorage.token}`}});
        return response.data;
    } catch(e){
        console.log(e);
        return fallo_token.data;
    }
}

export const admin_titulares = async () => {
    const LOGIN_ENDPOINT = `${SERVER_URL}/api/admin`;

    try {
        let response = await axios.get(LOGIN_ENDPOINT,{ headers: {"Authorization" : `Bearer ${localStorage.token}`}});
        return response.data;
    } catch(e){
        console.log(e);
        return fallo_token.data;
    }
}

export const admin_registro = async (data) => {
    const SIGNUP_ENDPOINT = `${SERVER_URL}/api/admin`;
    try {
        let response = await axios({
            method: 'post',
            responseType: 'json',
            url: SIGNUP_ENDPOINT,
            data: data,
            headers: {"Authorization" : `Bearer ${localStorage.token}`}
          });

        return response.data;

            } catch(e){
                console.log(e);
                return fallo_token.data;
            }
}

export const admin_titular_actualizar = async (titular, data) => {
    const LOGIN_ENDPOINT = `${SERVER_URL}/api/admin/${titular}`;

    try {
        let response = await axios.put(LOGIN_ENDPOINT, data,{ headers: {"Authorization" : `Bearer ${localStorage.token}`}});
        return response.data;
    } catch(e){
        console.log(e);
        return fallo_token;
    }
}

export const admin_titular_borrar = async (data) => {
    const LOGIN_ENDPOINT = `${SERVER_URL}/api/admin/${data.comite_id}/${data.representante_id}`;

    try {
        let response = await axios.delete(LOGIN_ENDPOINT, { headers: {"Authorization" : `Bearer ${localStorage.token}`}});
        return omitir_token.data;
    } catch(e){
        console.log(e);
        return fallo_token.data;
    }
}

export const admin_actualizar_titular = async (data) => {
    const LOGIN_ENDPOINT = `${SERVER_URL}/api/admin/${data.comite_id}/${data.codigo_id}/${data.representante_id}/nuevo-titular`;

    try {

        let response = await axios.put(LOGIN_ENDPOINT, data, { headers: {Authorization : `Bearer ${localStorage.token}`} });

        return response.data;

    } catch(e){
        console.log(e);
        return fallo_token.data;
    }
}

export const admin_actualizar_representante = async(representante_id, data) => {
    const LOGIN_ENDPOINT = `${SERVER_URL}/api/admin/${representante_id}`;

    try {
        let response = await axios.put(LOGIN_ENDPOINT,data, { headers: {"Authorization" : `Bearer ${localStorage.token}`}});
        return response.data;
    } catch(e){
        console.log(e);
        return fallo_token.data;
    }
}

export const admin_titular_comite_representante = async (representante) => {

    const LOGIN_ENDPOINT = `${SERVER_URL}/api/admin-info/${representante}`;

    try {
        let response = await axios.get(LOGIN_ENDPOINT,{ headers: {"Authorization" : `Bearer ${localStorage.token}`}});
        return response.data;
    } catch(e){
        console.log(e);
        return fallo_token.data;
    }

}

export const historial_representante = async (id_representante) => {
    

    const LOGIN_ENDPOINT = `${SERVER_URL}/api/historial/${id_representante}`;

    try {
        let response = await axios.get(LOGIN_ENDPOINT,{ headers: {"Authorization" : `Bearer ${localStorage.token}`}});
        return response.data;
    } catch(e){
        console.log(e);
        return fallo_token.data;
    }
}
